import { render, staticRenderFns } from "./RsaPazienteSocioRiabilitativoModalEdit.vue?vue&type=template&id=6a3c54a9"
import script from "./RsaPazienteSocioRiabilitativoModalEdit.vue?vue&type=script&lang=js"
export * from "./RsaPazienteSocioRiabilitativoModalEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports